<template>
  <div class="flex-1 space-x-4 space-y-2">
    <NBadge size="sm" badge="soft" label="Badge" />

    <NBadge size="lg" badge="solid" label="Badge" />

    <NBadge size="20px" badge="outline" label="Badge" />
  </div>
</template>
